$(function () {
    // Get current SKU
    const current_sku = $('input[type=hidden]#hidden-product-sku').val();
    const product_type = $('input[type=hidden]#hidden-product-type').val();
    const product_is_ready_to_ship = $('input[type=hidden]#hidden-ready-to-ship-enabled').val();

    // Initialize Options Object
    let selected_options = {
        "sku": '',
        "dress_size": '',
        "dress_length": '',
        "color": ""
    };

    // If dress length dropdown exists in Ready-to-Ship Master product PDP
    // we disable it
    if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
        $('.product-select--dress-length select').prop('disabled', true);
    }
    
    // Check to see if SessionStorage exists
    const session_exists = sessionStorage.getItem("selected_options");
    if (session_exists && (current_sku == JSON.parse(session_exists).sku)) {
        selected_options.sku = JSON.parse(session_exists).sku;
        selected_options.dress_size = JSON.parse(session_exists).dress_size;
        selected_options.dress_length = JSON.parse(session_exists).dress_length;
        selected_options.color = JSON.parse(session_exists).color;
        
        // If session exists, reselect previous User selections
        if (selected_options.color != '') {
            if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
                // do nothing;
                // For Ready-to-Ship products of type Dress we don't want the reapply the selected color
                // We only want to do it if we are in the Dress-by-Color type or any other Non-Ready-to-Ship Products
            } else {
                $('.swatch-element.' + selected_options.color).click().find('input[type=radio]').prop('checked', true);

                $('.infinite-option-size-select select, .product-select--size select').prop('disabled', false);            
            }            
        }

        if (selected_options.dress_size != '') {
            const size_select =  $('.infinite-option-size-select select').length > 0 ? $('.infinite-option-size-select select') : $('.product-select--size select');            

            if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
                // DO NOTHING
                // For Ready-to-Ship products of type Dress we don't want the reapply the selected Size
                // We only want to do it if we are in the Dress-by-Color type or any other Non-Ready-to-Ship Products
            } else {
                size_select.val(selected_options.dress_size);
            }
            
            // If dress-by-color Product we set the custom dropdown selected value
            if (product_type == 'dress-by-color') {
                $('.custom-dropdown .selected span').text(selected_options.dress_size);                
            }
        }

        if (selected_options.dress_length != '') {            
            $('.product-select--dress-length select').val(selected_options.dress_length);
        }

        // Set variant ID if there was a page load or reload
        setVariantID(selected_options.dress_size, selected_options.dress_length);
        handleEnableAddToCart();
    } else {
        // Initialize SessionStorage
        selected_options.sku = current_sku;
        sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
        handleEnableAddToCart();
    }    

    // Init Tooltips
    if ($('.colorSelector').length > 0 || $('.exclusive-readonly').length > 0) {
        $('.tooltip').tooltipster({
            theme: 'tooltipster-noir',
            maxWidth: 250,
            animation: 'grow',
        });
    }

    if ($('.product-template__container').length > 0) {
        // Thumbnail slider
        var slickOptions = {
            vertical: true,
            verticalSwiping: false,
            centerMode: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: false
        };

        // Init slider
        var slider = $('.thmb-slider').slick(slickOptions);
        let isSliding = false;

        // Feature image Slider
        var slickOptionsMain = {
            centerMode: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
        };

        // Init slider
        var sliderMain = $('.slider-main').slick(slickOptionsMain);

        // Custom slider buttons event
        $('.control-down').on('click', function () {
            if (isSliding) {
                return;
            }

            slider.slick('next');
            sliderMain.slick('next');
        });

        $('.control-up').on('click', function () {
            if (isSliding) {
                return;
            }

            slider.slick('prev');
            sliderMain.slick('prev');
        });

        $('.prev-btn').on('click', function () {
            if (isSliding) {
                return;
            }

            sliderMain.slick('prev');
        });

        $('.next-btn').on('click', function () {
            if (isSliding) {
                return;
            }

            sliderMain.slick('next');
        });

        slider.on('beforeChange', function () {
            isSliding = true;
        });

        sliderMain.on('beforeChange', function () {
            isSliding = true;
        });

        slider.on('afterChange', function (event, slick, currentSlide) {
            isSliding = false;
            setSliderDotActive(currentSlide);
        });

        sliderMain.on('afterChange', function (event, slick, currentSlide) {
            isSliding = false;
            setSliderDotActive(currentSlide);
            slider.slick('slickGoTo', currentSlide);
        });

        $('.thmb').on('click', function () {
            if (isSliding) {
                return;
            }

            slider.slick('slickGoTo', parseInt($(this).attr('data-slide-index')));
            sliderMain.slick('slickGoTo', parseInt($(this).attr('data-slide-index')));
        });

        // If the user selects a swatch and if product images have Ghost color dresses
        // we activate the slider to show that colored dress
        var all_slider_thumbs = $('.thmb-slider .thmb');
        $('.swatch-element').on('click keyup', function (e) {            
            if (e.type == 'click' || (e.type == 'keyup' && e.keyCode == 13)) {                
                var selected_swatch = $(this).attr('data-colorname-value').toLowerCase();
                setSwatchSelectValue(selected_swatch);
                selected_options.color = selected_swatch;
                sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
                handleEnableAddToCart();
    
                let results = all_slider_thumbs.filter(function (item, index, array) {
                    return ($(this).data("color") !== "" && $(this).data("color") == selected_swatch);
                });
    
                if (results.length > 0) {
                    results.first().click();
                }
    
                // If Master Product is of type Ready-to-Ship
                // we redirect to Dress-by-Color Variation on Swatch click
                if (product_is_ready_to_ship == 'true') {
                    // Reset selected options
                    selected_options = {
                        "sku": '',
                        "dress_size": '',
                        "dress_length": '',
                        "color": ""
                    }
                    sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
                    window.location = $(this).attr('data-rts-redirect-link');
                }
            }
        });

        // Zoom effect
        $('.slide')
            // tile mouse actions
            .on('mouseover', function () {
                $(this).children('img').css({ 'transform': 'scale(' + $(this).attr('data-scale') + ')' });
            })
            .on('mouseout', function () {
                $(this).children('img').css({ 'transform': 'scale(1)' });
            })
            .on('mousemove', function (e) {
                $(this).children('img').css({ 'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + '%' });
            });

        // Handle Quantity input Add/Substract events
        const quantity_input = $('input.product-form__qty');
        $('button.quantity-btn').on('click', function (e) {
            e.preventDefault();
            let current_quantity = quantity_input.val();

            if ($(this).hasClass('add-qty')) {
                current_quantity++;
            } else {
                current_quantity--;
            }
            // Make sure quantity is not zero or less
            if (current_quantity <= 0) {
                current_quantity = 1;
            }

            quantity_input.val(current_quantity);

            return false;
        });

        let is_boldmetrics = ($('input[type=hidden]#hidden-product-boldmetrics-enabled').val() === 'true');
        if ($('.size-chart-link-popup').length > 0) {
            // Init open Size guide modal on appended Size guide link
            $('.size-chart-link-popup').magnificPopup({
                type: 'inline',
                midClick: true
            });

            if (is_boldmetrics) {
                // if true we add event listener for click on appended Fit check link
                $('.fit-link-modal').on('click', function (e) {
                    e.preventDefault();
                    $('.boldmetrics-ssc-button, #ssc-boldmetrics-activator').click();
                    return false;
                });
            }
        }

        // -------------- Delivery Date Service ------------------
        const collectionName = $('input[type=hidden]#hidden-product-collection').val();
        $(document).ready(function () {
            $.ajax({
                url: 'https://store.b2c.amsale.com/delivery_date_check/' + collectionName + '?platform=b2c',
                context: document.body,
                success: function (data) {
                    var currentDate = new Date(data.value.toString());
                    var formattedDate = moment.utc(currentDate).format("L");
                    const hidden_eta_input = $('#hidden-product-estimated-date');
                    const is_holiday = $('.estimated-delivery-date.is-holiday-date').length > 0;
                    const eta_date_element = $('.estimated-delivery-date p#delivery_service_desc');
                    eta_date_element.attr('data-mto-date', formattedDate);

                    if (!is_holiday) {
                        eta_date_element.find('span.delivery-date').text(formattedDate);
                        hidden_eta_input.val(eta_date_element.data().mtoDate);
                    } else {
                        hidden_eta_input.val(eta_date_element.data().holidayDate);
                    }                    
                },
                error: function (msg) {
                    console.log('An error occured with the Delivery Date Endpoint AJAX call');
                    console.log('status', msg.status);
                    console.log('statusText', msg.statusText);
                }
            });
        });

        // Add to Cart Submit Click Handler
        $('button[type=submit].product-form__cart-submit').on('click', function (e) {
            // Color
            if($('.colorSelector').length > 0) {
                if ($('.swatch-element.active-swatch').length <= 0) {
                    e.preventDefault();
                    displayUserFeedbackMessage('error', 'Color missing', 'Please select a color.');
                    return false;
                }
            }

            // Size
            if ($('.custom-ddlist').length > 0) {
                if ($('.custom-ddlist .custom-dropdown .selected span').html() === '') {
                    e.preventDefault();
                    displayUserFeedbackMessage('error', 'Size missing', 'Please select a size.');
                    return false;
                }
            }
            
            if ($('form.product-form .product-select--size select').length > 0) {
                if ($('.product-select--size select').val() == '') {
                    e.preventDefault();
                    displayUserFeedbackMessage('error', 'Size missing', 'Please select a size.');
                    return false;
                }
            }            

            if ($('form.product-form #infiniteoptions-container').html().length > 0) {
                if ($('.spb-select select').val() == '') {
                    e.preventDefault();
                    $('#infiniteoptions-container').addClass('select-error');
                    displayUserFeedbackMessage('error', 'Size missing', 'Please select a size.');                    
                    return false;
                }
            }
            
            // Dress length
            if ($('form.product-form .product-select--dress-length select').length > 0) {
                if ($('.product-select--dress-length select').val() == '') {
                    e.preventDefault();
                    displayUserFeedbackMessage('error', 'Dress Length missing', 'Please select a length.');
                    return false;
                }
            }
        });
      

        // When InfiniteOptions Select appears apply some logic        
        document.arrive(".infinite-option-size-select select", function () {
            if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
                $(this).prop('disabled', true);
            } else {
                if (selected_options.color != '') {
                    $(this).prop('disabled', false);
                }

                if (selected_options.dress_size != '') {
                    $(this).val(selected_options.dress_size);
                    $(this).prop('disabled', false);
                }
            }
            

            handleEnableAddToCart();            
        });

        // Handle Variant options Change events
        // Store selections in SessionStorage and check Add to Cart State
        $(document).on('change', '.infinite-option-size-select select', function(){
            if (document.readyState == "complete") {
                if ($(this).val() != '') {
                    $('#infiniteoptions-container').removeClass('select-error');
                }

                selected_options.dress_size = $(this).val();
                sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
                handleEnableAddToCart();
            }
        });
        
        $(document).on('change', '.product-select--size select', function(){
            if (document.readyState == "complete") {
                selected_options.dress_size = $(this).val();
                sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
                handleEnableAddToCart();
            }
        });

        $(document).on('change', '.product-select--dress-length select', function(){
            if (document.readyState == "complete") {
                selected_options.dress_length = $(this).val();
                sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
                handleEnableAddToCart();
            }
        });
        
        // Custom Ready-to-Ship Dropdown Events
        // Show options on dropdown click
        const custom_select = $('.custom-dropdown .selected');
        custom_select.on('click keypress', function(e){            
            $(this).next().show();
        });

        // Hide Options on outside click or ESC keypress
        $(document).bind('click', function(e) {
            var $clicked = $(e.target);            
            if (! $clicked.parents().hasClass("custom-dropdown")) {
                custom_select.next().hide();
            }
        });

        $(document).on('keyup',function(evt) {
            if (evt.keyCode == 27) {
                custom_select.next().hide();
            }
        });

        // Custom dropdown Option click Handler
        $(document).on('click keypress', '.custom-dropdown .ddlist-options ul li', function(){
            $('.custom-dropdown .ddlist-options ul li').removeClass('active-selection');

            if (!$(this).hasClass('disabled')) {
                // Set Estimated Delivery Date value
                $(this).addClass('active-selection');
                const hidden_eta_input = $('#hidden-product-estimated-date');
                const hidden_saletype = $('input[type=hidden]#product-properties-saletype');
                const eta_date_element = $('.estimated-delivery-date p#delivery_service_desc');
                const is_holiday = $('.estimated-delivery-date.is-holiday-date').length > 0;

                if ($(this).hasClass('rts')) {
                    hidden_eta_input.val(eta_date_element.data().instockDate);
                    hidden_saletype.val('INSTOCK');
                } else {
                    if (!is_holiday) {
                        hidden_eta_input.val(eta_date_element.data().mtoDate);
                    } else {
                        hidden_eta_input.val(eta_date_element.data().holidayDate);
                    }
                    hidden_saletype.val('MTO');
                }

                // Set Custom dropdown Selected Value and hide Options
                custom_select.find('span.current-selected-value').text($(this).find('span.variant-value').text());
                custom_select.next().hide();
                // Select Size in hidden dropdown and trigger Select Change
                $('.product-select--size select').val($(this).find('span.variant-value').text()).change();
                // Set Selected Variant from Hidden Select
                $('.product-form__variants').val($(this).data('variant-id'));
                // Update URL Param
                let url= new URL(window.location.href);
                url.searchParams.set('variant', $(this).data('variant-id'));
                window.history.replaceState(null, null, url );
            }          
        });

        if ($('.product-select--RTS').length > 0) {
            const product_id = $('.custom-dropdown .ddlist-options ul').data('product-id');

            if (product_id) {                
                const api_endpoint = "https://api.ecom.amsale.com/api/inventory/" + product_id;
                // Call API endpoint to retrieve 
                $.ajax({
                    type: "GET",
                    url: api_endpoint,                    
                    dataType: 'json',
                    success: function(data, textStatus) {
                    //Get Product Inventory Data
                    if (textStatus === 'success') {
                        handleGenerateDropdownHTML(data);
                        setHiddenFieldValues();
                    }                  
                    },
                    error: function() {
                        displayUserFeedbackMessage('error', 'Error', "Sorry. An error occured.<br>Please refresh the page<br>and try again.");
                    }
                });
            }            

            /*$(document).on('change', '.product-select--dress-length.product-select--RTS select', function(e) {
                const product_inventories = TEMP_ARRAY.inventory;             

                if (window.product_inventory_with_id) {
                    custom_ddl.empty();
                    let DDL_html = "";
    
                    if ($(this).val() == 'Standard') {
                        for(let i = 0; i < window.product_inventory_with_id.dress_by_color.standard.length; i++) {
                            let dbc_obj = window.product_inventory_with_id.dress_by_color.standard[i];

                            if (dbc_obj.inventory_qty >= 1) {
                                DDL_html += "<li class='option rts' role='option' data-variant-id='";
                                DDL_html += dbc_obj.id;
                                DDL_html += "'>";
                            } else {
                                DDL_html += "<li class='option mto' role='option' data-variant-id='";
                                DDL_html += dbc_obj.id;
                                DDL_html += "'>";
                            }

                            DDL_html += "<span class='variant-value'>";

                            if (isNumeric(dbc_obj.option1)) {
                                DDL_html += dbc_obj.option1;
                            } else if (isNumeric(dbc_obj.option2)) {
                                DDL_html += dbc_obj.option2;
                            } else {
                                DDL_html += dbc_obj.option3;
                            }

                            DDL_html +=  "</span>";

                            if (dbc_obj.inventory_qty >= 1) {
                                DDL_html += "<span>In Stock</span>";
                            } else {
                                DDL_html += "<span>Made to Order</span>";
                            }
                            
                            DDL_html += "</li>";         
                        }
                    } else {
                        for(let i = 0; i < window.product_inventory_with_id.dress_by_color.extra_length.length; i++) {
                            let dbc_obj = window.product_inventory_with_id.dress_by_color.extra_length[i];

                            if (dbc_obj.inventory_qty >= 1) {
                                DDL_html += "<li class='option rts' role='option' data-variant-id='";
                                DDL_html += dbc_obj.id;
                                DDL_html += "'>";
                            } else {
                                DDL_html += "<li class='option mto' role='option' data-variant-id='";
                                DDL_html += dbc_obj.id;
                                DDL_html += "'>";
                            }

                            DDL_html += "<span class='variant-value'>";

                            if (isNumeric(dbc_obj.option1)) {
                                DDL_html += dbc_obj.option1;
                            } else if (isNumeric(dbc_obj.option2)) {
                                DDL_html += dbc_obj.option2;
                            } else {
                                DDL_html += dbc_obj.option3;
                            }

                            DDL_html +=  "</span>";

                            if (dbc_obj.inventory_qty >= 1) {
                                DDL_html += "<span>In Stock</span>";
                            } else {
                                DDL_html += "<span>Made to Order</span>";
                            }
                            
                            DDL_html += "</li>";         
                        }
                    }

                    custom_ddl.append(DDL_html);
                }              
            });*/
        }
    }
});

// Set mobile slider dot active state
function setSliderDotActive(goToIndex) {
    const active_index = parseInt($('.slider-dot.active').data('slide-index'));
    $('.slider-dot').eq(active_index).removeClass('active');
    $('.slider-dot').eq(goToIndex).addClass('active');
}

function setSwatchSelectValue(value) {
    $('.product-select--color select.single-option-selector').val(capitalizeFirstLetters(value)).trigger('change');
}

function capitalizeFirstLetters(str) {
    return str.split('-').map(function (item) {
        return item.charAt(0).toUpperCase() + item.slice(1)
    }).join('-');
}

// Handle Add to Cart Button Disable State
function handleEnableAddToCart() {
    //$('button.product-form__cart-submit').prop('disabled', true);
    const size_select =  $('.infinite-option-size-select select').length > 0 ? $('.infinite-option-size-select select') : $('.product-select--size select');
    const length_select = $('.product-select--dress-length select');
    const swatch_selectors = $('.colorSelector');
    let valid_state = false;

    if (swatch_selectors.length == 0 && size_select.length == 0 && length_select.length == 0) {
        valid_state = true;
    } else if (swatch_selectors.length > 0 && size_select.length == 0 && length_select.length == 0) {
        if (swatch_selectors.find('.active-swatch').length > 0) {
            valid_state = true;
        }
    } else if (swatch_selectors.length > 0 && size_select.length > 0 && length_select.length > 0) {        
        if (swatch_selectors.find('.active-swatch').length > 0 && size_select.val() != '' && length_select.val() != '') {
            valid_state = true;
            
        }
    } else if (swatch_selectors.length > 0 && size_select.length > 0 && length_select.length == 0) {
        if (swatch_selectors.find('.active-swatch').length > 0 && size_select.val() != '') {
            valid_state = true;
            
        }
    } else if (swatch_selectors.length == 0 && size_select.length > 0 && length_select.length == 0) {
        if (size_select.val() != '') {
            valid_state = true;
        }
    } else if (swatch_selectors.length == 0 && size_select.length > 0 && length_select.length > 0) {        
        if (size_select.val() != '' && length_select.val() != '') {
            valid_state = true;
        }
    }

    if ($('.product__price dd span.price-item--regular').text().includes('Sold out') || $('button.product-form__cart-submit span').text().includes('Sold out')) {
        valid_state = false;
    }

    if (valid_state) {
        $('button.product-form__cart-submit').prop('disabled', false);
    }
}

// Return selected Color
function getCurrentColor() {
    let element = null;

    if ($('.colorSelector').length > 0) {
        element = $('.colorSelector');
    } else if ($('.product-form__selects.product-select--color').length > 0) {
        element = $('.product-form__selects.product-select--color');
    }

    if (element) {
        if (element.hasClass('colorSelector')) {
            return element.find('.active-swatch').attr('data-colorname-value');
        } else {
            return element.find('select.single-option-selector').val();
        }
    }

    return false;
}

function escapeRegExpMatch(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function isExactMatch(str, match) {
  return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str)
}

// On page load or reload if Session exists we set the proper variant ID
// If we don't cover this scenario, Add to cart will 
// add the first selected variant from the list which is wrong
function setVariantID(dress_size, dress_length) {
    let full_search_query = '';
    
    if (getCurrentColor() !== false && dress_size !== '' && dress_length !== '') {
        if ($('.product-form__selects.product-select--size').length > 0) {
            full_search_query = `${getCurrentColor()} / ${dress_size} / ${dress_length}`;
        } else {
            full_search_query = `${getCurrentColor()} / ${dress_length}`;
        }
    } else if (getCurrentColor() !== false && dress_size == '' && dress_length !== '') {
        full_search_query = `${getCurrentColor()} / ${dress_length}`;
    } else if (getCurrentColor() !== false && dress_size !== '' && dress_length == '') {
        if ($('.product-form__selects.product-select--size').length > 0) {
            full_search_query = `${getCurrentColor()} / ${dress_size}`;
        } else {
            full_search_query = getCurrentColor();
        }        
    } else if (getCurrentColor() !== false && dress_size == '' && dress_length == '') {
        full_search_query = getCurrentColor();
    } else if (getCurrentColor() == false && dress_size !== '') {
        full_search_query = dress_size;
    }

    if (full_search_query !== '') {
        $('select.product-form__variants option').each(function(){
            if (isExactMatch(full_search_query, $(this).text())) {
                $('select.product-form__variants').val($(this).val());
            }
        });
    }
}

function isNumeric(str) {
    if (typeof str != "string") return false // we only process strings!  
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
           !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

function handleGenerateDropdownHTML(data) {        
    const product_inventories = data.inventory;
          
    if (product_inventories.length > 0) {
        const custom_ddl = $('.custom-dropdown .ddlist-options ul');
        let DDL_html = "";     
        const soldout = custom_ddl.data('sold-out');
        for (let index = 0; index < product_inventories.length; index++) {                    
            const element = product_inventories[index];
            if (element.size != "XL" && element.location?.includes('318') && element.size != "SS" && element.size != "MM") {
                if (element.available) {
                    DDL_html += "<li class='option rts' role='option' tabindex='0' data-variant-id='";
                    DDL_html += element.variant_id;
                    DDL_html += "'>";
                } else {
                    if (soldout) {
                        DDL_html += "<li class='option mto disabled' role='option' tabindex='0'>";                            
                    } else {
                        DDL_html += "<li class='option mto' role='option' tabindex='0' data-variant-id='";
                        DDL_html += element.variant_id;
                        DDL_html += "'>";
                    }                        
                }
    
                DDL_html += "<span class='variant-value'>";
                DDL_html += element.size;                    
                DDL_html +=  "</span>";
    
                if (element.available) {
                    DDL_html += "<span>In Stock</span>";
                } else {
                    if (soldout) {
                        DDL_html += "<span>Sold Out</span>";
                    } else {
                        DDL_html += "<span>Made to Order</span>";
                    }                        
                }
                
                DDL_html += "</li>"; 
            }
        }

        custom_ddl.append(DDL_html);
        $('.custom-dropdown span.loading-data').removeClass('loading');
    }
}

// On page load if we have a session we reinstate missing values
function setHiddenFieldValues() {
    const current_sku = $('input[type=hidden]#hidden-product-sku').val();
    const eta_date_element = $('.estimated-delivery-date p#delivery_service_desc');
    const hidden_eta_input = $('#hidden-product-estimated-date');
    const session_exists = sessionStorage.getItem("selected_options");
    const is_holiday = $('.estimated-delivery-date.is-holiday-date').length > 0;
    if (session_exists && (current_sku == JSON.parse(session_exists).sku)) {
        current_dress_size = JSON.parse(session_exists).dress_size;
        
        const custom_options = $('.custom-dropdown .ddlist-options ul li');
        custom_options.each(function( index ) {
            if ($(this).find('span.variant-value').text() === current_dress_size) {
                if ($(this).hasClass('mto')) {
                    if (!is_holiday) {
                        hidden_eta_input.val(eta_date_element.data().mtoDate);
                    } else {
                        hidden_eta_input.val(eta_date_element.data().holidayDate);
                    }
                    $('input[type=hidden]#product-properties-saletype').val('MTO');
                } else {
                    $('input[type=hidden]#product-properties-saletype').val('INSTOCK');
                    hidden_eta_input.val(eta_date_element.data().instockDate);
                }
            }
        })
    }   
}